import React from 'react';
import { Home, Grid, Search } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Grid, label: 'Categories', path: '/#categories' },
  { icon: Search, label: 'Search', path: '/search' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (path: string) => {
    if (path.startsWith('/#')) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(path.slice(2));
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      navigate(path);
    }
  };

  return (
    <nav className="lg:hidden fixed bottom-6 left-6 right-6 z-50">
      <div className="glass-card rounded-[2rem] p-2 flex items-center justify-around shadow-2xl theme-transition border-white/10">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path === '/#categories' && location.pathname === '/' && window.location.hash === '#categories');
          
          return (
            <button
              key={item.label}
              onClick={() => handleNav(item.path)}
              className={`flex flex-col items-center gap-1 p-2 rounded-2xl min-w-[64px] transition-all active:scale-90 ${
                isActive 
                  ? 'text-blue-600 dark:text-blue-400 bg-blue-50/50 dark:bg-blue-500/10 scale-110' 
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              <span className={`text-[10px] font-bold tracking-tight ${isActive ? 'opacity-100' : 'opacity-0 h-0 overflow-hidden transition-all'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
